import { Container, ButtonGroup, Row, Col, Button } from "react-bootstrap";
import React, { useEffect, useMemo, useState } from "react";
import { TOTAL_CLAIM_BALANCE_NO_PAID } from "../../../graphql/orderGroup/query";
import { useLazyQuery } from "@apollo/client";
import {
    MdFingerprint,
    MdDoNotDisturbOn,
    MdError,
    MdDoDisturbOff,
    MdCheckCircle,
    MdCloudDone,
    MdDoneAll,
} from "react-icons/md";
import _ from "lodash";
import moment from "moment";

const keyLocalStorage = "CLAIM_BALANCE_REPORT::";

function BtnClaimBalanceReport({
    cdFillter,
    listpage,
    setlistpage,
    isClaimBalance,
    setIsClaimBalance,
    isFetch,
    start,
    end,
    type,
    total
}) {
    //TODO CALL API CLAIM BALANCE
    const [loading, setLoading] = useState(false);

    // TODO useState total
    const [invalidPaid, setInvalidPaid] = useState(0);
    const [noPaid, setNoPaid] = useState(0);
    const [noticeNoPaid, setNoticeNoPaid] = useState(0);
    const [waitingConfirm, setWaitingConfirm] = useState(0);
    const [claimBalance, setClaimBalance] = useState(0);
    const [notClaimBalance, setNotClaimBalance] = useState(0);
    const [printOrder, setPrintOrder] = useState(0);
    const [userConfirm, setUserConfirm] = useState(0);
    const [completedCount, setCompletedCount] = useState(0);
    const [checkDate, setCheckDate] = useState(false);
    const [checkType, setCheckType] = useState(false);
    const [localData, setLocalData] = useState(null);


    //TODO LOCAL STORAGE
    const getLocalStorage = () => {
        let SHOP_ID = localStorage.getItem("SHOP");
        const newKey = `${keyLocalStorage}SHOP::${SHOP_ID}`; //`${keyLocalStorage}START::${start}::END${end}::TYPE::${type}`
        const data = getItemClaimBalanceReport({ key: newKey });
        return data;
    };
    const setLocalStorage = (data) => {
        let SHOP_ID = localStorage.getItem("SHOP");
        const newKey = `${keyLocalStorage}SHOP::${SHOP_ID}`; //`${keyLocalStorage}START::${start}::END${end}::TYPE::${type}`
        // setItemClaimBalanceReport({
        //     key: newKey,
        //     value: data,
        //     // expireTime: 60,
        // });
        // setTimeout(() => {
        //     return;
        // }, 100);
    };

    //TODO GQL
    const [
        getTotalOrderGroupClaimBalance,
        {
            data: totalOrderGroupClaimBalance,
            loading: totalOrderGroupClaimBalanceLoading,
        },
    ] = useLazyQuery(TOTAL_CLAIM_BALANCE_NO_PAID, { fetchPolicy: "network-only" });

    useEffect(() => {
        // const result = getLocalStorage();
        // if (result) {
        //     setLocalData(result);
        // } else {
        //     if (totalOrderGroupClaimBalanceLoading) return;
        //     getClaimBalanceFromAPI();
        // }
        if (totalOrderGroupClaimBalanceLoading) return;
        getClaimBalanceFromAPI();
    }, [checkDate, cdFillter, type, total]);

    useEffect(() => {
        setCheckDate(true);
        // getClaimBalanceFromAPI();
    }, [start, end]);

    useEffect(() => {
        setCheckType(true);
    }, [type]);

    //TODO Set total
    useEffect(() => {
        // if (localData) {
        //     // console.log("data from local");
        //     setNoPaid(localData?.no_paid?.total);
        //     setInvalidPaid(localData?.invalidPaid?.total);
        //     setNoticeNoPaid(localData?.noticeNoPaid?.total);
        //     setWaitingConfirm(localData?.waitingConfirm?.total);
        //     setClaimBalance(localData?.claimBalance?.total);
        //     setPrintOrder(localData?.printOrder?.total);
        //     setUserConfirm(localData?.userConfirm?.total);
        // } else 

        if (totalOrderGroupClaimBalance) {
            // console.log("data from api");
            setNoPaid(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.no_paid?.total
            );
            setInvalidPaid(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.invalidPaid
                    ?.total
            );
            setNoticeNoPaid(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.noticeNoPaid
                    ?.total
            );
            setWaitingConfirm(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.waitingConfirm
                    ?.total
            );
            setClaimBalance(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.claimBalance
                    ?.total
            );
            setNotClaimBalance(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.notClaimBalance
                    ?.total
            );
            setPrintOrder(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.printOrder
                    ?.total
            );
            setUserConfirm(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.userConfirm
                    ?.total
            );

            setCompletedCount(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.completed?.total ??
                total?.COMPLETED ??
                total?.completed ??
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.userConfirm?.total ??
                0
            );

            //TODO set local storage
            // setLocalStorage(totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance);
        }
    }, [totalOrderGroupClaimBalance]);

    const getClaimBalanceFromAPI = async () => {
        try {
            setLoading(true);
            let SHOP_ID = await localStorage.getItem("SHOP");
            let _where = {
                shop: SHOP_ID,
            };

            if (!_.isEmpty(cdFillter)) {
                const splitDateTime = (dateString) => {
                    const date = new Date(dateString);
                    const datePart = date.toISOString().split('T')[0];
                    const timePart = date.toISOString().split('T')[1].split('.')[0];
                    return datePart;
                };

                let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
                let endDateComponents = splitDateTime(cdFillter?.createdAt_lt);

                _where = {
                    ..._where,
                    start: startDateComponents,
                    end: endDateComponents,
                };
            }
            if (checkType) {
                _where = {
                    ..._where,
                    type: type,
                };
            }
            const _orderGroupData = await getTotalOrderGroupClaimBalance({
                variables: {
                    where: _where,
                },
            });
        } catch (error) {
            console.log("get order group total claim balance error: ", error);
        }
    };
    return (
        <div className="box-status-report">
            <button
                type="button"
                className={`btn ${listpage === "PAYMENT_STILL_INCOMPLETE"
                    ? "btn-warning"
                    : "btn-outline-warning"
                    } p-0`}
                onClick={() => {
                    setlistpage("PAYMENT_STILL_INCOMPLETE");
                }}
            >
                <div className="d-flex justify-content-center p-1">
                    <MdDoNotDisturbOn className="mt-1" /> &nbsp; ຍອດເງີນບໍ່ຖືກຕ້ອງ
                </div>
                <div>ຈຳນວນ: {invalidPaid ?? 0}</div>
                {/* <div className="p-0">ຊໍາລະເງີນບໍ່ຄົບຕາມຍອດເງີນຂອງອໍເດີ</div> */}
            </button>

            <button
                type="button"
                className={`btn ${listpage === "CREATED" ? "btn-danger" : "btn-outline-danger"
                    } p-0`}
                onClick={() => {
                    setlistpage("CREATED");
                }}
            >
                <div className="d-flex justify-content-center p-1">
                    &nbsp;
                    <MdDoDisturbOff className="mt-1" />
                    &nbsp; ອໍເດີ້ເຂົ້າ
                </div>
                <div>ຈຳນວນ: {noPaid ?? 0}</div>
                {/* <div className="p-0">ລຳລັບອໍເດີທີ່ລູກຄ້າບໍ່ມີການເຄື່ອນໄຫວ</div> */}
            </button>

            <button
                type="button"
                className={`btn ${listpage === "IMAGE_NOT_YET_PAID"
                    ? "btn-danger"
                    : "btn-outline-danger"
                    } p-0`}
                onClick={() => {
                    setlistpage("IMAGE_NOT_YET_PAID");
                }}
            >
                <div className="d-flex justify-content-center p-1">
                    <MdError className="mt-1" /> &nbsp; ແຈ້ງຍອດແຕ່ບໍ່ໂອນ
                </div>
                <div>ຈຳນວນ: {noticeNoPaid ?? 10}</div>
                {/* <div className="p-0">ລູກຄ້າແຈ້ງຍອດແຕ່ຍັງບໍ່ຊຳລະຫລືແຈ້ງຍອດຜີດ</div> */}
            </button>
            <button
                type="button"
                className={`btn ${listpage === "WAITINGCONFIRM" ? "btn-warning" : "btn-outline-warning"
                    } p-0`}
                onClick={() => {
                    setlistpage("WAITINGCONFIRM");
                }}
            >
                <div className="d-flex justify-content-center p-1">
                    <MdFingerprint className="mt-1" />
                    &nbsp; ລໍຖ້າການຢືນຢັນ
                </div>
                <div>ຈຳນວນ: {waitingConfirm ?? 0}</div>
                {/* <div className="p-0">ອໍເດີທີ່ລໍຖ້າການຢືນຢັ້ນ</div> */}
            </button>
            <ButtonGroup vertical>
                <Button
                    type="button"
                    disabled={true}
                    variant="outline-info"


                >
                    <div className="d-flex justify-content-center p-1">
                        <MdDoneAll className="mt-1" />
                        &nbsp; ລາຍການທວງຍອດ
                    </div>
                    {/* <div>ຈຳນວນ: {claimBalance ?? 0}</div> */}
                    {/* <div className="p-0">ການທວງຍອດທັງຫມົດ</div> */}
                </Button>
                <ButtonGroup>
                    <Button
                        variant={`${isClaimBalance === 'true' ? "success" : "outline-success"}`}
                        onClick={() => {
                            setlistpage("");
                            setIsClaimBalance('true');
                        }}>{claimBalance ?? 0}</Button>
                    <Button
                        variant={`${isClaimBalance === 'false' ? "danger" : "outline-danger"}`}

                        onClick={() => {
                            setlistpage("");
                            setIsClaimBalance('false');
                        }}>{notClaimBalance ?? 0}</Button>
                </ButtonGroup>
            </ButtonGroup>

            <button
                type="button"
                className={`btn ${listpage === "USERCONFIRM" ? "btn-primary" : "btn-outline-primary"} p-0`}
                onClick={() => setlistpage("USERCONFIRM")}
            >
                <div className="d-flex justify-content-center p-1">
                    <MdCheckCircle className="mt-1" />
                    &nbsp; ກວດສອບແລ້ວ
                </div>
                <div>ຈຳນວນ: {userConfirm ?? 0}</div>
            </button>
            <button
                type="button"
                className={`btn ${listpage === "COMPLETED" ? "btn-success" : "btn-outline-success"} p-0`}
                onClick={() => setlistpage("COMPLETED")}
            >
                <div className="d-flex justify-content-center p-1">
                    <MdCheckCircle className="mt-1" />
                    &nbsp; ອໍເດີສຳເລັດ
                </div>
                <div>ຈຳນວນ: {completedCount ?? 0}</div>
            </button>
  
        </div>
    );
}

//TODO GET LOCAL STORAGE

// Function to get data from localStorage using the key
function getItemClaimBalanceReport({ key }) {
    try {
        const item = window.localStorage.getItem(key);
        if (!item) {
            // console.log("No data found for key:", key);
            return null;
        }

        const result = JSON.parse(item);
        const { expireTime, data } = result;

        // console.log("Local data:", result);

        // console.log("expireTime < Date.now() ", expireTime, Date.now(), expireTime < Date.now());
        // Check if the data has expired
        if (expireTime < Date.now()) {
            window.localStorage.removeItem(key);
            // console.log("Data has expired, removing item.");
            return null;
        }

        // Return the data if not expired
        // console.log("Data:", data);
        return data;
    } catch (error) {
        // console.error("Error parsing localStorage item:", error);
        return null;
    }
}

/**
 * Accepts the key, value, and expiry time as parameters.
 * Default expiry time is 5 minutes (300,000 milliseconds).
 * @param {string} key - The key under which the data will be stored.
 * @param {any} value - The value to store.
 * @param {number} [expireTime=300000] - The expiry time in milliseconds.
 */
function setItemClaimBalanceReport({ key, value, expireTime }) {
    const result = {
        data: value,
        expireTime: Date.now() + expireTime,
    };

    window.localStorage.setItem(key, JSON.stringify(result));
}

export default BtnClaimBalanceReport;
